import { authApi } from "../api/authApi";
import { getToken } from "../utils/getToken";

export const authService = {
  getBrandList: async (): Promise<string | null> => {
    const token = getToken();
    if (!token) return null;

    try {
      const response = await authApi.getBrands(token);
      return response.data.result.brand;
    } catch (error) {
      console.error("Failed to fetch brandId:", error);
      return null;
    }
  },
};
